import React, { useEffect } from "react";

import { CreditPaymentMethod, PixPaymentMethod } from "./methods";
import { useActions } from "../../provider";

const PAYMENT_METHOD_COMPONENTS = {
  PIX: PixPaymentMethod,
  CREDIT: CreditPaymentMethod,
};

export function MakePayment() {
  const { actionsState, stepManager } = useActions();

  useEffect(() => {
    if(!actionsState?.paymentMethod) return stepManager.set('choose-payment');
  }, [actionsState?.paymentMethod])

  if(!actionsState?.paymentMethod) return null;

  const PaymentMethodComponent = PAYMENT_METHOD_COMPONENTS[actionsState.paymentMethod];

  return <PaymentMethodComponent />;
}
